import http from "./interceptors";
import Qs from 'qs'; //如果不需要请注释
import router from '@/router'

export function getRequest (url, data = {}) {
    const token = sessionStorage.getItem('token');
    const config = {
        params: data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };
    return new Promise((resolve, reject) => {
        http
            .get(url, config)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export function postRequest(url, data = {}) {
    const token = sessionStorage.getItem('token');
    const config = {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };
    return new Promise((resolve, reject) => {
        http
            .post(url, data, config)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export function getLoadRequest (url, data = {}) {
    const token = sessionStorage.getItem('token');
    const config = {
        params: data,
        headers: {
            'Authorization': 'Bearer ' + token
        },
        responseType: 'blob'  // 确保 responseType 设置为 'blob'
    };
    return new Promise((resolve, reject) => {
        http
            .get(url, config)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export function postExcelRequest(url, data = {}) {//导出excel类型，blob
    const token = sessionStorage.getItem('token');
    const config = {
        headers: {
            'Authorization': 'Bearer ' + token
        },
        responseType: 'blob'  // 确保 responseType 设置为 'blob'
    };
    return new Promise((resolve, reject) => {
        http
            .post(url, data, config)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}


export function deleteRequest(url) {
    const token = sessionStorage.getItem('token');
    const config = {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };
    return new Promise((resolve, reject) => {
        http
            .delete(url, config)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}
